import { axios } from "./core";
import { handleResponse, handleError } from "./response";

const single = "transaction";
const plural = "transactions";

const getTransactions = (filter) =>
  axios.post(`/${plural}/get`, filter).then(handleResponse).catch(handleError);

const transactionAPI = {
  getTransactions,
};

export default transactionAPI;
